import React from 'react';
import { Link } from 'react-router-dom';
import '../../../pages/media/business/business.css'; 
import logo from '../../../assets/img/logo-color.png';

const JobHeader = () => {
  return (
    <header className="job-page-header job-recruitment-header">
      <div className="job-page-header-container">
        <div className="job-page-logo">
          <Link to="/"><img src={logo} alt="가까운물류" /></Link>
        </div>
      </div>
    </header>
  );
};

export default JobHeader;